var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFind = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,18.8c-0.1,0-0.3,0-0.4-0.1L16.3,17c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.7,1.7c0.2,0.2,0.2,0.5,0,0.7 C18.6,18.8,18.5,18.8,18.3,18.8z M9.6,18c-2.2,0-4.4-0.9-6-2.5c-1.6-1.6-2.5-3.7-2.5-6c0-2.2,0.9-4.4,2.5-6c1.6-1.6,3.7-2.5,6-2.5 c1.1,0,2.2,0.2,3.2,0.6c1,0.4,1.9,1,2.7,1.8c0.8,0.8,1.4,1.7,1.8,2.7c0.4,1,0.6,2.1,0.6,3.2c0,1.1-0.2,2.2-0.6,3.2 c-0.4,1-1,1.9-1.8,2.7c-0.8,0.8-1.7,1.4-2.7,1.8C11.8,17.8,10.7,18,9.6,18z M9.6,2.2c-2,0-3.8,0.8-5.2,2.2C2.9,5.7,2.2,7.6,2.2,9.6 s0.8,3.8,2.2,5.2C5.7,16.2,7.6,17,9.6,17c1,0,1.9-0.2,2.8-0.6c0.9-0.4,1.7-0.9,2.4-1.6c0.7-0.7,1.2-1.5,1.6-2.4 c0.4-0.9,0.6-1.9,0.6-2.8c0-1-0.2-1.9-0.6-2.8S15.5,5,14.8,4.3c-0.7-0.7-1.5-1.2-2.4-1.6C11.5,2.4,10.6,2.2,9.6,2.2z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFind, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/find.e986b6be.svg";
export { ForwardRef as ReactComponent };